<!--
 * @Author: ZhaoG
 * @Date: 2025-04-14 16:18:19
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-04-23 15:00:32
 * @FilePath: \pp-fe\src\app\shop\components\shopHead.vue
 * @Description: 
-->
<template>
  <div class="head clearfix">
    <div class="content clearfix">
      <!-- <div class="logo fl">
        <router-link to="/">
          <el-image
            style="width: 206px; height: 68px; margin-left: 25px"
            :src="require('@/config/assets/images/protalLogo.png')"
          ></el-image>
        </router-link>
      </div> -->

      <!-- <div class="clearfix"></div> -->
      <div
        class="classes"
        style="    width: 1824px;height: 52px;overflow-x: auto"
      >
        <!-- <div class="all-classes fl">全部分类</div> -->
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#0089EF"
          popper-class="my-popover"
        >
          <div
            v-for="(item, index) in brandList"
            :key="index"
            :index="item.activeIndex + ''"
          >
            <el-menu-item :index="index + ''" v-if="item.activeIndex == '0'">
              <router-link :to="item.to">
                {{ item.name }}
              </router-link>
            </el-menu-item>
            <el-menu-item
              ref="shouye"
              v-else-if="!item.child"
              :index="item.activeIndex + ''"
            >
              <router-link :to="item.to">
                <a>{{ item.name }}</a>
              </router-link>
            </el-menu-item>
            <el-submenu :index="index + ''" v-else-if="item.child">
              <template slot="title">
                <a @click="handleClick1(item, index)">{{ item.name }}</a>
              </template>
              <el-menu-item
                class="el-menu-content item1"
                v-for="item1 in item.child"
                :key="item1.activeIndex"
                :index="item1.activeIndex + ''"
                style="
                  borderBottom: 2px dashed #ccc;
                "
              >
                <a
                  style="
                    display: block;fontSize: 12px;fontWeight: 500;
                  "
                  @click="handleClick(item1, item1.activeIndex)"
                  >{{ item1.name }}</a
                >
              </el-menu-item>
            </el-submenu>
          </div>
          <el-menu-item index="10" v-if="isShow"
            ><a :href="href" target="_blank">需求上报</a></el-menu-item
          >
        </el-menu>

        <!--        <ul>-->
        <!--          <li v-for="(item,index) in brandList" :key="index">{{item.name}}</li>-->
        <!--        </ul>-->
      </div>
      <div class="search fl">
        <el-input
          v-model="value"
          class="search-input"
          placeholder="请输入公告/公示名称"
        >
          <i
            slot="suffix"
            @click="handleSearch"
            class="el-input__icon el-icon-search"
          ></i>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import { announcementPageSource } from "@/setting/setting";
import Cookies from "js-cookie";
// import { queryAllSmpPermissionList } from "../api/shopping";

export default {
  name: "shopHead",
  data() {
    return {
      activeIndex: this.$route.query.activeIndex || "0",
      activeIndex1: this.$route.query.activeIndex1 || "0",
      href: "",
      isShow: false,
      value: "",
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL)
    };
  },
  computed: {
    ...mapGetters({
      brandList: "getBrandList"
    })
  },
  watch: {
    $route: {
      handler(to, from) {
        console.log(to, from, "route");
        if (to.path == "/") {
          try {
            this.$refs.shouye[0].$el.click();
            this.value = "";
          } catch (err) {
            console.log(err);
          }
        }
        if (
          from.path == "/announcementDetail" &&
          to.path == "/announcementsList"
        ) {
          this.value = "";
        }
      }
    }
  },
  created() {},
  async mounted() {
    await this.$store.dispatch("getNavTree");
    // 为了方便使用《集采价格统计表》，在门户集采展示专栏增加入口 start
    if (this.brandList.length) {
      this.brandList.forEach(item => {
        if (item.id == "1803") {
          let obj = {
            name: "集采价格统计",
            parentId: "1803",
            activeIndex: "18031",
            id: "18031"
          };
          item.child.unshift(obj);
        }
      });
    }
    // 为了方便使用《集采价格统计表》，在门户集采展示专栏增加入口 end
    this.activeIndex = this.brandList[0].activeIndex;
    if (this.$route.query.source) {
      const { parentId, sourceId } = this.$route.query;
      this.$store.dispatch("setCurrentBrand", {
        parentId,
        childId: sourceId
      });
    }
    this.getQueryAllSmpPermissionList();
  },
  methods: {
    ...mapActions(["setName"]),
    handleSearch() {
      this.setName(this.value); //vuex里边的方法
      this.$router.push({
        path: "/searchList"
      });
    },

    getLianJie() {
      if (Cookies.get("access_token")) {
        this.purchaseAgentId = JSON.parse(
          localStorage.getItem("agentIdList")
        ).purchaseAgentId;
        let href = "";
        if (this.baseUrl.indexOf("dev01") != -1) {
          href = `https://dev01-scpma.iccec.cn/demandManagement/demandManagementList/List?a=${this.purchaseAgentId}`;
        } else if (this.baseUrl.indexOf("test01") != -1) {
          href = `https://test01-scpma.iccec.cn/demandManagement/demandManagementList/List?a=${this.purchaseAgentId}`;
        } else if (this.baseUrl.indexOf("uat01") != -1) {
          href = `https://uat01-scpma.iccec.cn/demandManagement/demandManagementList/List?a=${this.purchaseAgentId}`;
        } else {
          href = `https://scpma.iccec.cn/demandManagement/demandManagementList/List?a=${this.purchaseAgentId}`;
        }
        this.href = href;
        // window.open(href, "_blank");
      } else {
        this.href =
          this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
          "?redirectUrl=" +
          this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
      }
    },
    //

    async getQueryAllSmpPermissionList() {
      // setTimeout(() => {
      this.isShow = true;
      this.getLianJie();
      // }, 500);
      // const { xqsjPermissionIds, xqsjEnterPermissionIds } = (
      //   await queryAllSmpPermissionList({})
      // ).data.data;
      // // console.log(xqsjPermissionIds, xqsjEnterPermissionIds,"111111111111111");
      // let id = JSON.parse(localStorage.getItem("userInfo")).openId;

      // if (xqsjPermissionIds.length && xqsjEnterPermissionIds.length && id) {
      //   if (
      //     xqsjEnterPermissionIds.some(e => id == e) &&
      //     xqsjPermissionIds.some(e => id == e)
      //   ) {
      //     this.isShow = true;
      //     this.getLianJie();
      //   } else {
      //     false;
      //   }
      // }
    },
    handleClick(item) {
      console.log(item, "handleClick");
      if (item.activeIndex != "18031") {
        this.$router.push({
          path: "/announcementsListNew",
          query: {
            source: item.source,
            activeIndex: item.activeIndex,
            sourceId: item.id,
            parentId: item.parentId
          }
        });
        this.$store.dispatch("setCurrentBrand", {
          parentId: item.parentId,
          childId: item.id
        });
      } else {
        // 为了方便使用《集采价格统计表》，在门户集采展示专栏增加入口 start
        if (Cookies.get("access_token")) {
          this.supplyAgentId = JSON.parse(
            localStorage.getItem("agentIdList")
          ).supplyAgentId;
          let href = "";
          if (this.baseUrl.indexOf("dev01") != -1) {
            href = `https://dev01-smp.iccec.cn/report/aggregate_purchase_price/list?a=${this.supplyAgentId}`;
          } else if (this.baseUrl.indexOf("test01") != -1) {
            // href = `https://test01-smp.iccec.cn/contractManagement/materialContractApproval/approvalList?a=${this.supplyAgentId}`;
            href = `https://test01-smp.iccec.cn/report/aggregate_purchase_price/list?a=${this.supplyAgentId}`;
          } else if (this.baseUrl.indexOf("uat01") != -1) {
            href = `https://uat01-smp.iccec.cn/report/aggregate_purchase_price/list?a=${this.supplyAgentId}`;
          } else {
            href = `https://smp.iccec.cn/report/aggregate_purchase_price/list?a=${this.supplyAgentId}`;
          }
          window.open(href, "_blank");
        } else {
          window.location.href =
            this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
            "?redirectUrl=" +
            this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
        }
        // 为了方便使用《集采价格统计表》，在门户集采展示专栏增加入口 end
      }
    },
    handleClick1(item) {
      this.$router.push({
        path: "/"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
input::-webkit-input-placeholder {
  color: red;
  /* 设置placeholder文字颜色 */
  font-size: 13px !important;
  /* 设置placeholder文字大小 */
  line-height: 26px !important;
}

/deep/ .el-input__suffix {
  top: 0px !important;
}

.search {
  margin-top: 9px !important;
  border: 0px !important;
  width: 320px !important;
}

.classes {
  margin-top: 0px !important;
}

.search-input {
  float: right !important;
  height: 30px !important;
  width: 300px !important;
  border-radius: 18px;
  border: 1px solid #d5d5d5;
}

/deep/ .el-input__inner {
  background-color: transparent !important;
}

.clearfix {
  display: flex;
}

/deep/ .el-submenu__icon-arrow {
  right: 3px;
  margin-top: -3px;
}

/deep/.el-submenu__title {
  height: 43px !important;
  line-height: 43px;
  font-size: 16px !important;
  padding: 0 20px 0 0 !important;
  // margin-right: 20px !important;
}

/deep/ .el-submenu {
  // margin-right: 30px !important;
}

.el-input /deep/ input.el-input__inner {
  border: none !important;
}

.shopping-main .head .content .classes ul li:first-of-type {
  margin-left: 0;
  padding-left: 0;
}

.svg-icon {
  width: 100% !important;
  height: 68px !important;
}

.header-new-drop {
  border: 0px solid #00487f !important;
  border-radius: 5px; // 注意:这里转深度书写样式修改它的 div 下方 after 样式

  /deep/ ul {
    &:after {
      border-bottom-color: rgba(0, 0, 0, 0.75) !important;
    }
  }
}

/deep/ .el-menu-item:nth-child(1) {
  margin: 0 !important;
  padding-left: 0 !important;
  padding-right: 0px !important;
}

/deep/ .el-menu-item {
  margin: 0 !important;
  padding-left: 0 !important;
  padding-right: 0px !important;
}

.el-menu-item a,
.el-dropdown a {
  font-size: 16px !important;
  font-weight: 500 !important;
}

.item1 a {
  font-size: 14px !important;
  font-weight: 500 !important;

  text-align: center;
}

.item1 {
  color: #4a4a4a;
}

.is-active {
  color: rgb(0, 137, 239);
}

.el-dropdown-menu {
  border: 0px solid #00487f !important;
  border-radius: 5px;
}

// el-dropdown组件展示小三角
/deep/.popper__arrow {
  display: block !important;
}

.el-dropdown-menu__item {
  margin: 0 10px;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-align: center !important;
  border-bottom: 2px dashed #ccc !important;
}

.el-dropdown-selfdefine {
  &:hover {
    color: #0089ef !important;
  }
}

.el-menu-item:focus,
.el-menu-item:hover {
  background-color: inherit;
}

/deep/ .el-submenu__title:focus,
/deep/ .el-submenu__title:hover {
  background-color: inherit !important;
}

.el-menu-demo {
  div:nth-child(3) {
    .el-submenu {
      .el-submenu__title {
        padding: 0 15px !important;
      }
    }
  }
}

.shopping-main .head .content .classes ul li:nth-child(1) {
  // min-width: 96px !important;
  margin-right: 20px !important;
  height: 43px !important;
  line-height: 43px !important;
  font-size: 16px !important;
}

.shopping-main .head .content .classes ul li:nth-child(7) {
  // min-width: 96px !important;
  margin-right: 20px !important;
}

.shopping-main .head .content .classes ul {
  // width: 536px !important;
  margin-top: 6px;
}

/* 滚动条整体样式 */
::-webkit-scrollbar {
  width: 12px;
  /* 宽度 */
  height: 12px;
  /* 高度 */
}

/* 滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #888;
  /* 背景色 */
  border-radius: 6px;
  /* 圆角 */
  border: 3px solid transparent;
  /* 边框 */
  background-clip: content-box;
  /* 背景裁剪 */
}

/* 滑块悬停样式 */
::-webkit-scrollbar-thumb:hover {
  background-color: #555;
  /* 悬停时的背景色 */
}

/* 轨道样式 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* 背景色 */
  border-radius: 6px;
  /* 圆角 */
}

// .shopping-main .head .content .classes ul li{
//   height: 40px !important;
//   line-height: 40px !important;
//   margin: 0 15px !important;
// }
.el-submenu__title {
  a {
    font-size: 16px !important;
    font-weight: 500 !important;
  }
}
</style>
